import { createApi } from '@reduxjs/toolkit/query/react';

import { fetchbase } from './apis.util';

export const baseApi = createApi({
  baseQuery: fetchbase,

  refetchOnFocus: true,

  refetchOnMountOrArgChange: true,

  tagTypes: [
    'Buildings',
    'Building',
    'Zones',
    'Zone',
    'ZoneCategories',
    'ZoneServiceItems',
    'CurrentUser',
    'Employees',
    'Users',
    'AssignedBuildings',
    'UserNotifications',
    'GetDecal',
    'Onboarding',
    'ScansCount',
    'SubscribersCount',
    'ScheduleProgress',
    'ServiceInterruptions',
    'ItemsInCart',
    'ItemsInCartCount',
  ],

  endpoints: () => ({}),
});
